
export function configGet() {
	return {
    type: 'CONFIG_GET',
	}
};
